import { groupEventColors } from '../utils/color-utils';

export const YEAR_MODE = 'year';
export const MONTH_MODE = 'month';
export const DAY_MODE = 'day';
export const WEEK_MODE = 'week';
export const TIMELINE_MODE = 'timeline';

export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';
export const UNCATEGORIZED = 'Uncategorized';
export const MY_TASKS = 'my_tasks';
export const AGENCY_TASKS = 'agency_tasks';
export const GROUP_MODE = 'group';

export const MinutesInDay = 1440;
export const CustomModeTimeStep = 30;
export const DayModeDays = 1;
export const WeekModeDays = 7;
export const TimelineModeDays = 3;

String.prototype.toCamelCase = function () {
  return this.replace(/\b(\w)/g, function (match, capture) {
    return capture.toUpperCase();
  }).replace(/\s+/g, '');
};

export const POSSIBLE_MODES = {
  DAY_MODE: {
    value: DAY_MODE,
    name: DAY_MODE.toCamelCase(),
    disabled: false,
    visible: true,
    title: DAY_MODE.toCamelCase(),
  },
  WEEK_MODE: {
    value: WEEK_MODE,
    name: WEEK_MODE.toCamelCase(),
    disabled: false,
    visible: true,
    title: WEEK_MODE.toCamelCase(),
  },
  MONTH_MODE: {
    value: MONTH_MODE,
    name: MONTH_MODE.toCamelCase(),
    disabled: false,
    visible: true,
    title: MONTH_MODE.toCamelCase(),
  },
  YEAR_MODE: {
    value: YEAR_MODE,
    name: YEAR_MODE.toCamelCase(),
    disabled: false,
    visible: true,
    title: YEAR_MODE.toCamelCase(),
  },
  TIMELINE_MODE: {
    value: TIMELINE_MODE,
    name: TIMELINE_MODE.toCamelCase(),
    disabled: false,
    visible: true,
    title: TIMELINE_MODE.toCamelCase(),
  },
};

const groupColors = groupEventColors();

export const CALENDAR_FILTERS = {
  my_tasks: {
    value: MY_TASKS,
    label: 'Show My Tasks',
    color: groupColors[0],
    checked: true,
    title: 'My Tasks (Visible only to me)',
  },
  agency_tasks: {
    value: AGENCY_TASKS,
    label: 'Show Agency Tasks',
    color: groupColors[1],
    checked: true,
    title: 'Agency Tasks (Visible to the whole agency)',
  },
};

export const isCustomMode = (mode) => !(mode == MONTH_MODE || mode == YEAR_MODE);
